<template>
  <database-management
    :headings="headings"
    :entries="entries"
    :loading="loading"
    :sort="sort"
    :sort-dir="sortDir"
    :show-delete="true"
    @showModal="(id) => {
      selectedEntryId = id
      showModal()
    }"
    @updateSort="(key) => {
      updateSort(key)
    }">
    <template v-slot:heading>Department Management</template>
    <template v-slot:list>
      <department-management-list-item
        v-for="department in sortedEntries"
        :key="department.id"
        :department="department"
        @edit="(id) => {
            selectedEntryId = id
            showModal()
          }"
        @delete="(id) => {
            selectedEntryId = id
            showDeleteModal()
          }"/>
    </template>
    <template v-slot:modal>
      <department-management-modal
        ref="modal"
        :department="selectedEntryIndex !== -1 ? entries[selectedEntryIndex] : defaultEntry"
        @create="(department) => { add(department) }"
        @update="(department) => { update(department) }"
      />
    </template>
    <template v-slot:departmentsModal>
      <department-management-departments-modal
        ref="departmentsModal"
        :department="selectedEntryIndex !== -1 ? entries[selectedEntryIndex] : defaultEntry"
        :departments="entries"
        :users="departmentUsers"
        @update="(department) => { update(department) }"
        @added="(entries) => { updateEntries(entries) }"
      />
    </template>
  </database-management>
</template>

<script>
import { notify, http, alert } from 'utils'
import DepartmentManagementListItem from './DepartmentManagementListItem'
import DepartmentManagementModal from './DepartmentManagementModal'
import DepartmentManagementDepartmentsModal from './DepartmentManagementDepartmentsModal'
import DatabaseManagement from './templates/DatabaseManagement'
import { databaseManagement } from 'mixins'

export default {
  mixins: [databaseManagement],
  components: {DatabaseManagement, DepartmentManagementModal, DepartmentManagementDepartmentsModal, DepartmentManagementListItem},

  data () {
    return {
      departmentUsers: []
    }
  },

  created () {
    http.get('departments', { params: { per_page: 300 } })
      .then((response) => {
        this.entries = response.data.data
        this.loading = false
      })
  },

  methods: {
    showDeleteModal () {
      this.loading = true
      http.get(`departments/${this.selectedEntryId}/users`)
        .then((response) => {
          this.loading = false
          if (response.data) {
            this.departmentUsers = response.data
            return this.showDepartmentsModal()
          }

          const confirmAlertOptions = {
            title: 'Delete Department',
            text: 'Are you sure you want to delete this department?'
          }

          return alert.confirm(confirmAlertOptions)
            .then(() => {
              return http.delete(`departments/${this.selectedEntryId}`)
                .then((response) => {
                  this.entries = response.data.data
                  notify.success('Successfully deleted department.')
                })
            })
            .catch(() => {
              notify.error('Deletion has been canceled. Nothing changed.')
              return Promise.resolve()
            })
        }).catch(() => {
          this.loading = false
          notify.error('Something went wrong, please try again.')
          return Promise.resolve()
        })
    },

    updateEntries (entries) {
      this.entries = entries
    }
  }
}
</script>
